import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getComponentViewByInstance } from '@angular/core/src/render3/context_discovery';
import { BehaviorSubject } from 'rxjs';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class SubjectDetail{
  PreStudentExamSubjectID:number;
	StudentExamID:number;
	CoursePartID:number;
	BranchID:number;
	SyllabusID:number;
	SubjectID:number;
	CategoryID:number;
	PaperID:number;
	SectionID:number;
	ExamCentreCollegeID:number;
	FreshRepeaterFlag:string;
	SubjectStatusFlag:string;
	CreatedLoginID:number;
	UpdatedLoginID:number;
}
export class SubjectChange{
  SubjectChangeRequestID: number;
  StudentID: number;
  ApplicationNO:number;
  ApplicationDate: string;
  ExamInstanceID: number;
  CoursePartID: number;
  CollegeID: number;
  BranchID: number;
  SubjectChangeApplicationFees: number;
  SubjectChangeApplicationDDNO: number;
  SubjectChangeApplicationBankName: string;
  SubjectChangeApplicationDDDate: string;
  SubjectChangeApplicationStatus: string;
  DeleteFlag: string;
  CreatedLoginID: number;
  UpdatedLoginID: number;
  SubjectDetail:SubjectDetail;
}


@Injectable({
  providedIn: 'root'
})
export class SubjectchangeService {

  constructor(
    private dataService: DataAccessService) {
  }

   GetSubjectChangeData(StudentID,CourseID,ExamInstanceID) {debugger
    this.dataService.setControllerName = '/ExamForm/';
    this.dataService.setMethodName = 'GetSubjectChangeData?StudentID='+ StudentID + '&CourseID=' + CourseID + '&ExamInstanceID='+ ExamInstanceID + ''; // setting method name from API controller.
    return this.dataService.getAll<SubjectChange[]>()
  }
   GetStudentExamIDForPortal(StudentID, CoursePartID, BranchID, ExamInstanceID) {debugger
    this.dataService.setControllerName = '/PortalStudentSubjectChange/';
    this.dataService.setMethodName = 'GetStudentExamIDForPortal?StudentID='+ StudentID +'&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&ExamInstanceID='+ExamInstanceID; // setting method name from API controller.
    return this.dataService.getAll<SubjectChange[]>()
  }
   GetSubjectDetailsCurrentForPortalRequest(StudentExamID, CoursePartID, BranchID) {debugger
    this.dataService.setControllerName = '/ExamForm/';
    this.dataService.setMethodName = 'GetSubjectDetailsCurrentForPortalRequest?StudentExamID='+ StudentExamID +'&CoursePartID='+CoursePartID+'&BranchID='+BranchID; // setting method name from API controller.
    return this.dataService.getAll<SubjectChange[]>()
  }
  public GetSequenceNO(Formnm) {debugger
    this.dataService.setControllerName = '/PortalBranchChange/';
    this.dataService.setMethodName = 'GetSequenceNO?Formnm='+ Formnm; // setting method name from API controller.
    return this.dataService.getAll<SubjectChange[]>()
  }
   save(data) {debugger
    this.dataService.setControllerName = '/PortalStudentSubjectChange/';
    this.dataService.setMethodName = 'PostInsertPortalStudentSubjectChangeNEW'; // setting method name from API controller.
    return this.dataService.add<SubjectChange[]>(data) 
  }
  public GetChangedSubjectData(StudentID,SubjectChangeRequestID) {debugger
    this.dataService.setControllerName = '/PortalStudentSubjectChange/';
    this.dataService.setMethodName = 'GetChangedSubjectData?StudentID='+ StudentID +'&SubjectChangeRequestID='+SubjectChangeRequestID + '';
    return this.dataService.getAll<SubjectChange[]>()
  }
  public CancelSubjectChangeApplication(ApplicationNO,StudentID,AcademicInstanceID,ResultQueryCode) {
    this.dataService.setControllerName = '/PortalStudentSubjectChange/';
    this.dataService.setMethodName = 'CancelSubjectChangeApplication?ApplicationNO='+ApplicationNO+'&StudentID='+StudentID+'&AcademicInstanceID='+AcademicInstanceID+'&ResultQueryCode='+ResultQueryCode+'';
    return this.dataService.getAll<SubjectChange[]>()
  }
  public GetUpdatePaymentStatusForSubjectChange(merchantTxnNo,ExamInstanceID,ApplicationNO,StudentID) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetUpdatePaymentStatusForSubjectChange?merchantTxnNo='+ merchantTxnNo + '&ExamInstanceID='+ExamInstanceID+'&ApplicationNO='+ApplicationNO +'&StudentID='+StudentID; // setting method name from API controller.
    return this.dataService.getAll<SubjectChange[]>()
  }
  public GetDataforSubjectChangeList(StudentID,ExamInstanceID,AcademicInstanceID,CoursePartID) {debugger
    this.dataService.setControllerName = '/PortalStudentSubjectChange/';
    this.dataService.setMethodName = 'GetDataforSubjectChangeList?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&AcademicInstanceID='+AcademicInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
    return this.dataService.getAll<SubjectChange[]>()
  }
  public CheckSubjectRequestStatusForNewRequest(StudentID,ExamInstanceID,CoursePartID) {debugger
    this.dataService.setControllerName = '/PortalStudentSubjectChange/';
    this.dataService.setMethodName = 'CheckSubjectRequestStatusForNewRequest?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
    return this.dataService.getAll<SubjectChange[]>()
  }
  public GetDocumentPathForSubjectChange(SubjectChangeRequestID) {debugger
    this.dataService.setControllerName = '/PortalStudentSubjectChange/';
    this.dataService.setMethodName = 'GetDocumentPathForSubjectChange?SubjectChangeRequestID='+ SubjectChangeRequestID
    return this.dataService.getAll<SubjectChange[]>()
  }

  public GetApplicationFormPrintForSubjectChange(StudentID,ApplicationNO,ExamInstanceID) {
    this.dataService.setControllerName = '/FormPrintReportCertficatesRequest/';
    this.dataService.setMethodName = 'GetApplicationFormPrintForSubjectChange?StudentID='+StudentID+'&ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID; // setting method name from API controller.
    return this.dataService.getAll<SubjectChange[]>()
  }
}
